import DownRightIcon from "@uui/CornerDownRight";

import Button, { ButtonProps } from "@mui/material/Button";
import styled from "@mui/material/styles/styled";

const JumpToButton = styled((props: ButtonProps) => (
  <Button startIcon={<DownRightIcon />} variant="text" {...props} />
))(({ theme }) => ({
  borderRadius: "4px",
  color: theme.palette.shades.neutral[500],
  fontSize: "0.875rem",
  fontFamily: theme.typography.fontFamilySecondary,
  fontWeight: 500,
  lineHeight: "19px",
  height: "24px",
  padding: "2px 4px 2px 6px",
  whiteSpace: "nowrap",
  width: "85px",
  flexShrink: 0,

  "&:hover": {
    color: theme.palette.shades.primary[500],
    backgroundColor: theme.palette.shades.ghost[500],
  },

  "& .MuiButton-startIcon": {
    marginRight: "6px",
  },

  "& svg": {
    width: "14px",
    height: "14px",
  },
}));

export default JumpToButton;
